import { BodyMetricsOverview } from "../../../common/components/bodyMetrics/BodyMetricsOverview/BodyMetricsOverview";
import { IBodyMetricsDataSource } from "../../../common/components/bodyMetrics/models/bodyMetricModels";
import { endpointsMetadata } from "../../../common/infrastructure/routes/endpointsMetadata";

const DATA_SOURCE: IBodyMetricsDataSource = {
  listEndpoint: endpointsMetadata.bodyMetric.getMyBodyMetrics,
  listQueryKey: [endpointsMetadata.bodyMetric.getMyBodyMetrics],
  addEndpoint: endpointsMetadata.bodyMetric.addMyBodyMetric,
  deleteEndpoint: endpointsMetadata.bodyMetric.deleteMyBodyMetric,
};

const INTRO = {
  storageKey: "myBodyMetricsIntro",
  title: "Какво са „Моите метрики“?",
  text:
    "Тук записвате тегло, ръст, телесни мазнини, обиколки и други показатели на тялото. " +
    "Докоснете метрика, за да видите как се променя във времето. Вашият треньор " +
    "също може да добавя стойности.",
};

/**
 * Portal page with the user's body metrics. Rendering lives in the reusable
 * BodyMetricsOverview; this page feeds it the caller-scoped endpoints.
 */
export const MyBodyMetrics = () => {
  return <BodyMetricsOverview dataSource={DATA_SOURCE} intro={INTRO} />;
};
